// Same as services/php/app/Http/Controllers/ReportsController.php
const REPORT_COLORS = [
    // http://tristen.ca/hcl-picker/#/hlc/7/0.9/FF937D/FBBC62
    '#FF937D',
    '#F599BB',
    '#B6B3E2',
    '#68CAD7',
    '#6ED3A2',
    '#B4CE6A',
    '#FBBC62',

    '#AB594B',
    '#A75F7E',
    '#7678A1',
    '#298C9A',
    '#36966F',
    '#7C9440',
    '#BC863B',

    // http://tristen.ca/hcl-picker/#/hcl/9/0.9/EF729B/DE8365
    '#EF729B',
    '#C087C6',
    '#749DD3',
    '#15AABD',
    '#25AE91',
    '#68AA62',
    '#9DA044',
    '#C69148',
    '#DE8365',
]

export function getReportColor(idx: number) {
    return REPORT_COLORS[idx % REPORT_COLORS.length]
}
